export default {
    tagKind: 'Field Name',
    type: 'Input Type',
    shard: 'Area',
    values: 'Possible Values',
    note: 'Notes',
    principalId: 'Item #',
};
